import { Skeleton } from 'antd';

/**
 * 与 OrderCancelDetailContent 布局一致的骨架屏：
 * DetailCard(状态) → DetailCard(取消原因) → DetailCard(商品列表) → CommentCard
 */
export const OrderCancelDetailContentSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {/* 状态 DetailCard */}
      <div className="bg-[var(--fett-bg-elevated)] rounded p-4 flex flex-col gap-3">
        <Skeleton.Input active size="small" className="!w-32 !min-w-0" />
      </div>

      {/* 取消原因 DetailCard（标题 + 右侧链接） */}
      <div className="bg-[var(--fett-bg-elevated)] rounded p-4 flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <Skeleton.Input active size="small" className="!w-48 !min-w-0" />
          <Skeleton.Button active size="small" className="!min-w-0" />
        </div>
        <Skeleton.Input active size="small" className="!w-full !min-w-0" />
      </div>

      {/* 商品列表 DetailCard */}
      <div className="bg-[var(--fett-bg-elevated)] rounded p-4 flex flex-col gap-3">
        <Skeleton.Input active size="small" className="!w-24 !min-w-0" />
        <div className="flex flex-col gap-3">
          {[1, 2].map((i) => (
            <div key={i} className="flex gap-3 items-start">
              <Skeleton.Avatar
                active
                shape="square"
                size={48}
                className="!rounded-[2px] !w-12 !h-12 flex-shrink-0"
              />
              <div className="flex-1 min-w-0 space-y-2">
                <Skeleton.Input active size="small" className="!w-full !min-w-0" />
                <div className="flex gap-2">
                  <Skeleton.Input active size="small" className="!w-16 !min-w-0" />
                  <Skeleton.Input active size="small" className="!w-20 !min-w-0" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CommentCard */}
      <div className="bg-[var(--fett-bg-elevated)] rounded p-4 flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <Skeleton.Input active size="small" className="!w-20 !min-w-0" />
          <Skeleton.Button active size="small" className="!min-w-0" />
        </div>
        <Skeleton.Input active size="small" className="!w-full !min-w-0" />
      </div>
    </div>
  );
};
